import ImageBuilding from "../ImageBuilding/ImageBuilding";
import React from "react";
import {BuildingBaseData, BuildingRequirementBuilding, BuildingRequirementNotBuilding} from "../../index";

import {useTranslationContext} from "../../../react/providers/TranslationContext";

type Props = {
    building: BuildingBaseData,
    hoverBuilding: BuildingBaseData,
    onMouseOver: () => void,
    onMouseOut: () => void,
    onClick: () => void,
}

export function BuildingCategoryEntry({building, onMouseOver, onMouseOut, onClick, hoverBuilding}: Props) {
    const requirementInfo = {
        type: null,
        level: null,
    };

    const { translate } = useTranslationContext();

    if (hoverBuilding !== null) {
        const require = hoverBuilding.prerequisites
            .filter(k => k.type === 'Building' && k.gid.includes(building.gid))[0] as BuildingRequirementBuilding;
        const blocked = hoverBuilding.prerequisites
            .filter(k => k.type === 'NotBuilding' && k.gid === building.gid)[0] as BuildingRequirementNotBuilding;

        if (require !== undefined) {
            requirementInfo.type = require.gid.indexOf(building.gid) === 0 ? 'required' : 'requiredAlt';
            requirementInfo.level = require.level;
        }
        if (blocked !== undefined) {
            requirementInfo.type = 'blocked';
        }
    }

    return <div
        className={'buildingContainer d-grid gap-2 align-items-center ' + (requirementInfo.type !== null ? 'buildingRequirementState-' + requirementInfo.type : '')}
        style={{ gridTemplateColumns: 'auto 1fr auto' }}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        onClick={onClick}
    >
        <ImageBuilding gid={building.gid} size={32} />
        <div>{translate('building_g' + building.gid)}</div>
        <div className='levelRequirementContainer'>{requirementInfo.level ?? ''}</div>
    </div>
}
